import { render, staticRenderFns } from "./AddEditWorkflow.vue?vue&type=template&id=6fe89680&scoped=true&"
import script from "./AddEditWorkflow.vue?vue&type=script&text=text%2Fbabel&lang=js&"
export * from "./AddEditWorkflow.vue?vue&type=script&text=text%2Fbabel&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe89680",
  null
  
)

export default component.exports